export enum FranchiseNames {
  Strive = 'strive',
  DesertDiamond = 'desertDiamond',
  Gnogaz = 'gnogaz',
  Gnogon = 'gnogon',
  Mothership = 'mothership',
  Rwb = 'rwb',
  Fwmi = 'fwmi',
  Deltaon = 'deltaon',
  Deltaab = 'deltaab',
}

export enum FranchiseThemes {
  Bnl = 'bnl',
  Rwb = 'rwb',
  Strive = 'strive',
  V1 = 'strive',
  V2 = 'rwb',
  V3 = 'v3',
}
